// 定义已触发的滚动深度，避免重复触发
var triggeredScrollDepths = new Set();

// 计算页面滚动百分比
function getScrollPercentage() {
  const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrollPosition = window.scrollY;
  return Math.round((scrollPosition / documentHeight) * 100);
}

// 检查并触发滚动事件
function checkScrollDepth() {
  var scrollPercentage = getScrollPercentage();
  var thresholds = [25, 50, 75, 100];

  thresholds.forEach(threshold => {
    if (scrollPercentage >= threshold && !triggeredScrollDepths.has(threshold)) {
      // 记录已触发的深度
      triggeredScrollDepths.add(threshold);
      // 推送事件到dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ "event_parameters": null });
      window.dataLayer.push({
        "event": "ga4Event",
        "event_name": "scroll",
        "event_parameters": {
          "percent_scrolled": threshold
        }
      });
    }
  });
}

// 添加滚动事件监听
window.addEventListener('scroll', function() {
  // 使用requestAnimationFrame来优化性能
  requestAnimationFrame(checkScrollDepth);
});

// 页面加载完成后初始化检查
document.addEventListener('DOMContentLoaded', checkScrollDepth);